<template>
    <div class="wbk-projects">
        <multiselect
            v-model="selectedRegions"
            :options="regionsData"
            :searchable="true"
            :close-on-select="false"
            :show-labels="false"
            :multiple="true"
            :without-tags="true"
            @select="updateRegionFilter"
            @remove="updateRegionFilter"
            label="name"
            :custom-label="(object) => `${object.name} (${object[countId]})`"
            track-by="id"
            tag-position="bottom"
            placeholder="Regionen">
            <template v-slot:tag="{ option, remove }">
                <span class="multiselect__tag">
                    <span>{{ stripTagName( option.name ) }} ({{ option[countId] }})</span>
                    <i tabindex="1" @keypress.enter.prevent="remove(option)"
                    @mousedown.prevent="remove(option)" class="multiselect__tag-icon"></i>
              </span>
            </template>
        </multiselect>
        <ul class="wbk-projects__list" v-if="projectsData">
            <li v-for="project in filteredProjectsData">
                <a :href="project.link" target="_blank">
                    <div class="wbk-projects__image">
                        <figure v-if="project.image">
                            <img :src="project.image" alt="">
                        </figure>
                    </div>
                    <div class="wbk-projects__content">
                        <span>{{ project.sponsor }}</span>
                        <h2>{{ project.name }}</h2>
                        <span>Laufzeit: {{ project.time }}</span>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import _filter from 'lodash/filter'

import { mapGetters, mapState } from 'vuex'

export default {
    name: 'WBKProjects',
    components: {
        'multiselect': Multiselect
    },
    data() {
        return {
            selectedRegions: [],
            countId: 'count'
        }
    },
    computed: {
        ...mapState( [
            'regionFilterset',
        ] ),
        ...mapGetters( [
            'regionsData',
            'actionFieldFilter',
            'regionFilter',
            'projectsData'
        ] ),
        filteredProjectsData() {
            const projectsByRegion = this.regionFilter.length
            ? _filter( this.projectsData, ( project ) => {
                return project.regions.some( region => this.regionFilter.includes( region ) )
            } )
            : this.projectsData

            const projectsByCatgory = this.actionFieldFilter.length && this.actionFieldFilter[0].id !== 0
            ? _filter( projectsByRegion, ( project ) => {
                return project.action_fields.some( actionField => this.actionFieldFilter[0].id === actionField )
            } )
            : projectsByRegion

            return projectsByCatgory
        }
    },
    methods: {
        updateRegionFilter( value ) {
            this.$store.dispatch( 'updateRegionsFilter', value.id )
        },
        updateSelectedRegions( value ) {
            if ( this.selectedRegions.includes( value ) ) {
                this.selectedRegions.splice( this.selectedRegions.indexOf( value ), 1 )
            } else {
                this.selectedRegions.push( value )
            }
        },
        handleTag( data ) {
            console.log( data )
        },
        stripTagName( name ) {
            let stringReplacement = ''

            if ( name.includes( '(Kreisfreie Stadt)' ) ) {
                stringReplacement = name.replace( '(Kreisfreie Stadt)', '(Krfr.St)' )
            } else {
                stringReplacement = name.replace( '(Landkreis)', '(Lkr)' )
            }
            return stringReplacement
        }
    },
    watch: {
        actionFieldFilter( value ) {
            let { slug } = value[0]

            this.countId = slug !== '' ? `count_${slug}` : 'count'
        }
    }
}
</script>

<style lang="scss">
    .wbk-projects {
        padding: 0 20px;

        &__list {
            list-style: none;
            padding: 0;
            margin: 0;
            overflow: hidden;

            a {
                display: flex;
                margin-top: 20px;
                text-decoration: none;

                figure {
                    padding: 0;
                    margin: 0;
                    margin-right: 15px;
                }

                span {
                    display: block;
                }
            }
        }
    }
</style>
